import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Link as RouterLink } from '@reach/router';
import { globalTheme } from '@cld/component-theme';
import { asStyledComponent } from '@cld/component-enhancer';
import { toDemo, toHome } from '../../../../router';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { messages } from '../../../../i18n';
import { Link as HeaderLink } from './Link';

const Root = styled.div`
  display: flex;
  margin-left: auto;
  
  > * {
    margin-left: ${globalTheme.spacing.md};
  }
`;

const LinksBase: FC = (({ ...rest }) => {
  const analytics = useAnalytics();

  return (
    <Root {...rest}>
      <RouterLink to={toHome()} onClick={() => analytics('navigate', 'overview')} data-test="header-overview-link">
        <HeaderLink className="selected">
          <FormattedMessage {...messages['landing.header.links.overview']} />
        </HeaderLink>
      </RouterLink>
      <RouterLink to={toDemo()} onClick={() => analytics('navigate', 'demo')} data-test="header-demo-link" >
        <HeaderLink>
          <FormattedMessage {...messages['landing.header.links.demo']} />
        </HeaderLink>
      </RouterLink>
      <a
        href="https://cloudinary.com/documentation/media_library_widget"
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => analytics('navigate', 'documentation')}
        data-test="header-documentation-link"
      >
        <HeaderLink>
          <FormattedMessage {...messages['landing.header.links.documentation']} />
        </HeaderLink>
      </a>
    </Root>
  );
});

export const Links = asStyledComponent(LinksBase);
